export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID; // eslint-disable-line prefer-destructuring
export const INTERCOM_BOOT = 'boot';
export const INTERCOM_ALIGNMENT = 'left';
export const INTERCOM_SHOW = 'show';
export const INTERCOM_SHUTDOWN = 'shutdown';
export const INTERCOM_SCRIPT_URL = 'https://widget.intercom.io/widget/';
export const INTERCOM_UPDATE = 'update';
export const THRESHOLD_TO_RETRY_INITIALIZATION = 200;
